import {
    getVideosPreview,
    VideosPreviewType,
} from "@infrastructure/Services/VideosPreviewService";
import { RequestCriteriaType } from "@infrastructure/Services/PostService.types";

export function fetcherVideosPreview(
    id: string,
    sortCriteria?: RequestCriteriaType,
): Promise<VideosPreviewType[]> {
    return getVideosPreview(id, sortCriteria);
}
